export class OTPError extends Error {
  public constructor() {
    super("OTP is required to continue");
  }
}
